(function () {
    "use strict";

    angular.module("app").controller("CisScreeningSearchController", CisScreeningSearchController);

    CisScreeningSearchController.$inject = ["controllerDecorator", "infiniteScrollDataSourceFactory", "screeningService", "cisScreening"];
    function CisScreeningSearchController(controllerDecorator, infiniteScrollDataSourceFactory, screeningService, cisScreening) {
        const vm = this;
        controllerDecorator.Decorate(vm, ["navigation", "files", "dialog"]);

        vm.DataSource = null;

        Object.defineProperty(vm, "Filter", { get: () => vm.DataSource.GetFilter() });
        Object.defineProperty(vm, "PageAndSort", { get: () => vm.DataSource.GetPageAndSort() });
        Object.defineProperty(vm, "Items", { get: () => vm.DataSource.Items() });

        vm.Open = function (request) {
            if (!request)
                return;
            vm.Navigator.Cis.OpenScreening(request.PublicId);
        };

        vm.SelectAllStatus = false;
        vm.BulkOperation = {
            SelectAll: function () {
                vm.SelectAllStatus = !vm.SelectAllStatus;

                for (const item of vm.DataSource.Items())
                    item.Selected = vm.SelectAllStatus;
            },
            CanExecute: () => getSelectedRequests().length > 0,
            CanSelect: () => ["New", "Completed"].includes(vm.Filter.Query),
            Execute: angular.noop
        };

        activate();

        function activate() {
            // init datasource
            vm.DataSource = infiniteScrollDataSourceFactory.Create(cisScreening.Search, v => vm.isLoadingRequests = v);

            // parse url
            vm.DataSource.ResetSearch();

            if (vm.Filter.Query === "New") {
                vm.BulkOperation.Execute = acceptSelection;
            }
            else if (vm.Filter.Query === "Completed") {
                vm.BulkOperation.Execute = confirmSelection;
            }

            vm.SetLoadingState(false);
        }

        function getSelectedRequests() {
            if (vm.DataSource.IsEmpty())
                return [];

            return vm.DataSource.Items().filter((req) => req?.Selected);
        }

        function confirmSelection() {
            screeningService.ConfirmCisResults({ Type: 'CIS', Items: getSelectedRequests() })
                .then(r => authenticateBeforeSigning(r.data))
                .catch(vm.ShowError);
        }

        function acceptSelection() {
            const screeningIds = getSelectedRequests().map(i => i.ScreeningId);

            if (screeningIds.length === 0)
                return;

            vm.SetLoadingState(true);
            cisScreening.Accept(
                { ScreeningIds: screeningIds },
                angular.noop,
                vm.ShowError,
                () => {
                    vm.SetLoadingState(false);
                    vm.DataSource.ResetSearch();
                }
            );
        }

        /**
        * Checks if the API call succeeded and prompts the user to authenticate themselves using their eId
        * @param {Object} result the result from an API call
        */
        function authenticateBeforeSigning(result) {
            if (!CheckResultReceived(result)) {
                vm.ShowError(result);
                return;
            }

            const options = {
                onEscape: true,
                closeButton: true,
                title: vm.getTranslation("GetFasRedirectionTitle"),
                templateUrl: vm.Settings.applicationPath + 'Account/ChangeFASLogin?returnurl=' + encodeURIComponent(vm.Navigator.CurrentPage)
            };
            vm.Dialog.Custom(options);
        }
    }
})();
